var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsExclamationMarkCircle = function SvgDlsExclamationMarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2zm-.06 38c-1.9 0-3.23-.81-3.23-3.01 0-2.11 1.33-3.01 3.23-3.01 1.86 0 3.19.9 3.19 3.01-.01 2.2-1.34 3.01-3.19 3.01zm2.47-10.32h-4.73L20.75 8h6.55l-.89 21.68z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_ExclamationMark_Circle.68329d34.svg";
export { SvgDlsExclamationMarkCircle as ReactComponent };